import React from 'react'
import Sidebar from './Sidebar'
import Banner from './Banner'


export default function Dashboards() {
  return (
    <>
    <Sidebar/>
    <Banner/>
    </>
  
  )
}
